export interface ILogViewData {
    id: number;
    message: string;
    level: string;
    timeStamp: string;
    exception: string;
    userName: string;
    module: string;
  }
  
  export default class LogViewData implements ILogViewData {
    id: number;
    message: string;
    level: string;
    timeStamp: string;
    exception: string;
    userName: string;
    module: string;
  
  constructor(
    id: number,
    message: string,
    level: string,
    timeStamp: string,
    exception: string,
    userName: string,
    module: string
    ) 
    {
      this.id = id;
      this.message = message;
      this.level= level;
      this.timeStamp=timeStamp;
      this.exception= exception;
      this.userName=userName;
      this.module=module;
    }
  }
  
  const defaultLogViewData = new LogViewData(
    0,
    "",
    "",
    "",
    "",
    "",
    ""
  );
  export { defaultLogViewData };
  